/*
 * Customer Login Component
 */

import React, { useState, useRef, useEffect } from 'react';
import {
  View,
  Heading,
  Text,
  TextField,
  Button,
  Flex,
  ProgressCircle,
  Well,
  Form
} from '@adobe/react-spectrum';
import Alert from '@spectrum-icons/workflow/Alert';
import {callAction} from "../utils/api";
import {useAuth} from "../context/AuthContext";
import {validateEmail} from "../utils/validation";

export function CustomerLogin({ ims , onLoginSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [passwordError, setPasswordError] = useState(null);

  const isMountedRef = useRef(true);
  useEffect(() => {
  return () => {
    isMountedRef.current = false;  
  };
}, []);

  console.log('ims on Login: ', ims)

  const validatePassword = (value) => {
    if (!value) {
      return 'Password is required';
    }
    return null;
  };

  const handleEmailChange = (value) => {
    setEmail(value);
    setEmailError(null);
    setError(null);
  };

  const handleEmailBlur = () => {
    setEmailError(validateEmail(email));
  };

  const handlePasswordChange = (value) => {
    setPassword(value);
    setPasswordError(null);
    setError(null);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate all fields
    const emailValidation = validateEmail(email);
    const passwordValidation = validatePassword(password);

    setEmailError(emailValidation);
    setPasswordError(passwordValidation);

    if (emailValidation || passwordValidation) {
      return;
    }

    setLoading(true);
    setError(null);

    try {

      const result = await callAction('cpm/authenticate', {
        body: {
          email: email,
          password: password,
        },
        requestData: {
          method: 'POST',
        },
        ims,
      });

      console.log('Login Result', result)

  
      if (!result.success) {
  throw new Error(result.message || 'Invalid credentials');
    }
        if (onLoginSuccess) {
          onLoginSuccess({
            accessToken: result.token,
            isLoggedIn: true,
            email: email, 
          });
        }

    } catch (err) {
      console.error('Login error:', err);
      if (isMountedRef.current) {
  setError(err.message || 'Login failed. Please check your credentials.');
  }
    } finally {
  if (isMountedRef.current) {
    setLoading(false);
  }
}
  };

  return (
    <View
      minHeight="100vh"
    >
      <Flex
        direction="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
      >
        <View
          backgroundColor="gray-50"
          padding={{ base: 'size-400', M: 'size-600' }}
          borderRadius="medium"
          maxWidth={{ base: '100%', M: 'size-6000' }}
          UNSAFE_style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
        >
          <Heading level={2} >
            Prescription Management
          </Heading>
          <Text marginBottom="size-400">
            Please login using your CPAP Shop account.
          </Text>

          <Form
            onSubmit={handleSubmit}
            validationBehavior="aria"
            aria-label="Customer login form"
            width="100%"
          >
            <Flex direction="column" gap="size-200">
              <TextField
                label="Email Address"
                name="email"
                value={email}
                onChange={handleEmailChange}
                onBlur={handleEmailBlur}
                type="email"
                isRequired
                autoFocus
                isDisabled={loading}
                width="100%"
                validationState={emailError ? 'invalid' : 'valid'}
                errorMessage={emailError}
                description="Enter your CPAP Shop account email"
              />

              <TextField
                label="Password"
                name="password"
                value={password}
                onChange={handlePasswordChange}
                type="password"
                isRequired
                isDisabled={loading}
                width="100%"
                validationState={passwordError ? 'invalid' : 'valid'}
                errorMessage={passwordError}
              />

              {error && (
                <Well marginTop="size-200">
                  <Flex direction="row" gap="size-100" alignItems="center">
                    <Alert color="negative" size="S" />
                    <Text>
                      <strong>Error:</strong> {error}
                    </Text>
                  </Flex>
                </Well>
              )}

              {loading ? (
                <Flex justifyContent="center" marginTop="size-200">
                  <ProgressCircle aria-label="Logging in" isIndeterminate />
                </Flex>
              ) : (
                <Button
                  variant="cta"
                  type="submit"
                  marginTop="size-200"
                  width="100%"
                  isDisabled={!email || !password || !!emailError || !!passwordError || loading}
                >
                  Login
                </Button>
              )}
            </Flex>
          </Form>
        </View>
      </Flex>
    </View>
  );
}
